import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import Intersect from 'vuetify/lib/directives/intersect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "persistent": "",
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": _vm.closeDialog
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.createTitle')) + "\n  ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [[_c(VBtn, {
          class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
          attrs: {
            "color": _vm.color,
            "disabled": !_vm.formValid,
            "rounded": "",
            "text": "",
            "data-cy": "create_template_button"
          },
          on: {
            "click": _vm.save
          }
        }, [_c(VIcon, {
          attrs: {
            "left": ""
          }
        }, [_vm._v("fal fa-plus")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.create')) + "\n      ")], 1)]];
      },
      proxy: true
    }])
  }, [!_vm.deviceTemplateLimitExceeded ? _c('div', [_c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "form",
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    staticClass: "ma-0",
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.title'),
      "hide-details": "",
      "rules": _vm.requiredRule,
      "required": "",
      "data-cy": "template_title_input"
    },
    model: {
      value: _vm.template.title,
      callback: function ($$v) {
        _vm.$set(_vm.template, "title", $$v);
      },
      expression: "template.title"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c('core-account-selector', {
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.template.tenantId,
      callback: function ($$v) {
        _vm.$set(_vm.template, "tenantId", $$v);
      },
      expression: "template.tenantId"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "loading": _vm.deviceDriversData.isLoading,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.deviceDriver'),
      "items": _vm.deviceDriversData.deviceDrivers,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.createServerRequest || !_vm.template.tenantId,
      "search-input": _vm.deviceDriversData.driverSearch,
      "item-text": "title",
      "item-value": "id",
      "hide-details": "",
      "rules": _vm.requiredRule,
      "required": "",
      "data-cy": "template_device_driver"
    },
    on: {
      "update:searchInput": function ($event) {
        return _vm.$set(_vm.deviceDriversData, "driverSearch", $event);
      },
      "update:search-input": function ($event) {
        return _vm.$set(_vm.deviceDriversData, "driverSearch", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n                    " + _vm._s(data.item.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")\n                  ")])], 1)];
      }
    }, {
      key: "append-item",
      fn: function () {
        return [_c('div', {
          directives: [{
            def: Intersect,
            name: "intersect",
            rawName: "v-intersect",
            value: _vm.endDriversIntersect,
            expression: "endDriversIntersect"
          }]
        })];
      },
      proxy: true
    }], null, false, 1447283110),
    model: {
      value: _vm.template.deviceDriverId,
      callback: function ($$v) {
        _vm.$set(_vm.template, "deviceDriverId", $$v);
      },
      expression: "template.deviceDriverId"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c('core-dtwin-finder', {
    attrs: {
      "label": _vm.$i18n_t('Common.digitalTwins.searchParentLabel'),
      "placeholder": _vm.$i18n_t('Common.digitalTwins.searchParentPlaceholder'),
      "tenantId": _vm.template.tenantId,
      "objectFilter": _vm.parentSelectorFilter,
      "disabled": !_vm.template.tenantId,
      "loadFullDtwinData": false,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "sameTenant": "",
      "required": "",
      "hideDetails": ""
    },
    model: {
      value: _vm.template.parentId,
      callback: function ($$v) {
        _vm.$set(_vm.template, "parentId", $$v);
      },
      expression: "template.parentId"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "disabled": _vm.deviceBridgesForAccount.length === 0,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.connector'),
      "items": _vm.deviceBridgesForAccount,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "rules": _vm.requiredRule,
      "return-object": "",
      "required": "",
      "data-cy": "template_account_connector"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemAvatar, [_c(VAvatar, {
          attrs: {
            "size": "32"
          }
        }, [_vm.bridgeTypesIcons[data.item.type] ? _c('img', {
          attrs: {
            "src": _vm.bridgeTypesIcons[data.item.type],
            "alt": data.item.name,
            "title": data.item.name
          }
        }) : _vm._e()])], 1), _c(VListItemContent, [_c(VListItemTitle, {
          domProps: {
            "innerHTML": _vm._s(data.item.name)
          }
        }), _c(VListItemSubtitle, [_vm._v("\n                    " + _vm._s(data.item.type.replace('bridge-', '')) + " (ID " + _vm._s(data.item.id) + ")\n                  ")])], 1)];
      }
    }], null, false, 411857261),
    model: {
      value: _vm.selectedBridge,
      callback: function ($$v) {
        _vm.selectedBridge = $$v;
      },
      expression: "selectedBridge"
    }
  }), !_vm.deviceBridgesLoading && _vm.template.tenantId && _vm.deviceBridgesForAccount.length === 0 ? _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.noConnectorText')) + "\n              "), _c('br'), _c('router-link', {
    attrs: {
      "to": "/connectors/list"
    }
  }, [_c('span', {
    class: `${_vm.color}--text`
  }, [_vm._v("\n                  » " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.noConnectorLink')) + "\n                ")])])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1) : _c('div', [_c(VAlert, {
    attrs: {
      "value": true,
      "color": "#d7d7d7"
    }
  }, [_c('i', {
    staticClass: "fal fa-exclamation-circle fa-lg",
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "value": true,
      "aria-hidden": "true"
    }
  }), _vm._v("\n       \n      "), _c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.limitOfTemplatesReached')) + "\n      ")]), _c('br'), _c('br'), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "color": "black"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.maximalLimitOfTemplates', {
    accountName: _vm.accountName,
    deviceTemplatesLimit: _vm.deviceTemplatesLimit
  })) + "\n      ")])])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };